import React, { useState, useEffect, useCallback, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Tooltip,
  Button,
  FormControlLabel,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";
//import { styled } from '@mui/material/styles';
import { Link, useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import update from "immutability-helper";

import { PeriodComponents, GetTermEvents } from "./TermComponents.js";
import { ComponentDragBox } from "./ComponentDragBox.js";
import { PeriodDropBox } from "./PeriodDropBox.js";
import { EventDropBox } from "./EventDropBox.js";
import EditPeriodDialog from "./EditPeriodDialog.js";
import EditEventDialog from "./EditEventDialog.js";
import Header from "./Header.js";
import backImg from "../../assets/icons/back.png";
import AlertDialog from "../../components/AlertDialog.js";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";

import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";
import {
  TERM_ADD_PERIOD_MUTATION,
  TERM_UPDATE_PERIOD_MUTATION,
  TERM_DELETE_PERIOD_MUTATION,
} from "../../graphQL/termPeriod";
import {
  CREATE_EVENT_MUTATION,
  EDIT_EVENT_MUTATION,
  DELETE_EVENT_MUTATION,
} from "../../graphQL/event_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: "7rem",
    minWidth: "1400px",
  },
  container: {
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    // height: "936px",
    borderRadius: "8px",
  },

  ComponentDragBox: {
    float: "left",
  },
  PeriodDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    //  textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  objectBoxStyle: {
    margin: 15,
    borderRadius: "8px",
    border: "1px solid lightGray",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  backStyle: {
    cursor: "pointer",
    borderRadius: "4px",
    height: 35,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
  dragIconBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 5,
    paddingRight: 2,
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    marginBottom: 5,
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  termNameTextStyle: {
    //minWidth: 200,
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 24,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    alignItems: "center",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  termNameTextBoxStyle: {
    paddingTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    display: "flex",
    alignItems: "center",
    minWidth: 200,
  },
  termNameFieldStyle: {
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      height: 40,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
}));
const CustomGridContainer = styled(Grid)(({ theme }) => ({
  ".MuiGrid-container": {
    flexWrap: "nowrap",
  },
}));
const StyledDivider = styled(Divider)(({ theme }) => ({
  flexGrow: 2,
}));

function TermAdd() {
  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const dividerRef = useRef(null);
  const [loadContent, setLoadContent] = useState(false);
  const [pathname] = useState(window.location.pathname);
  const [termName, setTermName] = useState("New Term");
  const [formId, setFormId] = useState();
  const [editedTermName, setEditedTermName] = useState("New Term");
  const [editingTermName, setEditingTermName] = useState(false);
  const [focusTermName, setFocusTermName] = useState(false);
  const [periodDataList, setPeriodDataList] = useState([]);
  const [addEditEventToPeridId, setAddEditEventToPeridId] = useState(null);
  const [lastDroppedComponent, setLastDroppedComponent] = useState(null);
  const [currentEditComponent, setCurrentEditComponent] = useState(null);
  const [openEditPeriodDialog, setOpenEditPeriodDialog] = useState(false);
  const [openEditEventDialog, setOpenEditEventDialog] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);

  const termEvents = GetTermEvents();
  //console.log("termEvents___", termEvents);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (
      periodDataList.length > 7 &&
      !addEditEventToPeridId &&
      dividerRef.current &&
      cardRef.current
    ) {
      // chnage Divider width according scrollWidth
      dividerRef.current.width = cardRef.current.scrollWidth;
      //scroll the Card component to the rightmost position after a new Period is added
      //cardRef.current.scrollLeft = cardRef.current.scrollWidth;
    }
    setAddEditEventToPeridId(null);
  }, [periodDataList]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else {
      window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [termStartDate, setTermStartDate] = useState();
  const [getTermStartDateQuery] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID);
  const [termAddPeriod] = useMutation(TERM_ADD_PERIOD_MUTATION);
  const [termUpdatePeriod] = useMutation(TERM_UPDATE_PERIOD_MUTATION);
  const [termDeletePeriod] = useMutation(TERM_DELETE_PERIOD_MUTATION);

  const [createEvent] = useMutation(CREATE_EVENT_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [editEvent] = useMutation(EDIT_EVENT_MUTATION);
  const [deleteEvent] = useMutation(DELETE_EVENT_MUTATION);

  useEffect(() => {
    (() => getTermStartDate())();
  }, []);
  const getTermStartDate = async () => {
    const {
      loading: loadingTermData,
      error: errorTermData,
      data: dataTermData,
    } = await getTermStartDateQuery({
      variables: {
        termUuid: "123456asdfgjkl458orkldfetyo58l,dje", //parseInt(termId),
      },
    });
    if (!loadingTermData && dataTermData && dataTermData.getTermDataByTermUuid) {
      setTermStartDate(dataTermData.getTermDataByTermUuid.startDate);
    }
  };

  // function setDateFormatFunc(date) {
  //   var d = new Date(date),
  //     month = "" + (d.getMonth() + 1),
  //     day = "" + d.getDate(),
  //     year = d.getFullYear();
  //
  //   if (month.length < 2) month = "0" + month;
  //   if (day.length < 2) day = "0" + day;
  //
  //   return [year, month, day].join("-");
  // }

  const handleDropPeriod = useCallback(
    component => setLastDroppedComponent(component),
    null
  );
  const handleDropEvent = useCallback((item, periodId) => {
    setAddEditEventToPeridId(periodId);
    setLastDroppedComponent(item);
  });

  const handleEditTermName = async () => {
    if (editedTermName.trim() != "") {
      setTermName(editedTermName);
      setEditingTermName(false);
    }
  };
  const handleDoneAddEditPeriodObjectToTerm = async (
    name,
    dateRange,
    startDate,
    endDate,
    desc,
    noOfWeeks,
    inSprint
  ) => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      periodId: currentEditComponent && currentEditComponent.periodId,
    });
    // console.log("foundRow______edit____", foundRow);
    if (foundRow) {
      updatedList = findAnd.changeProps(
        periodDataList,
        { periodId: foundRow.periodId },
        {
          name: name,
          dateRange: dateRange,
          startDate: startDate,
          endDate: endDate,
          desc: desc,
          noOfWeeks: noOfWeeks,
          inSprint: inSprint,
        }
      );
      // Update period's data in database
      let {
        loading: loadUpdateTermPeriod,
        error: errorUpdateTermPeriod,
        data: dataUpdateTermPeriod,
      } = await termUpdatePeriod({
        variables: {
          periodId: foundRow.periodId,
          name: name,
          desc: desc,
        },
      });
      console.log(dataUpdateTermPeriod);
      if (
        !loadUpdateTermPeriod &&
        dataUpdateTermPeriod &&
        dataUpdateTermPeriod.updateTermPeriod &&
        dataUpdateTermPeriod.updateTermPeriod.termPeriod
      ) {
        setAlertMsg({
          title: "Success",
          msg: 'Period "' + name + '" is successfully updated.',
        });
      } else if (errorUpdateTermPeriod) {
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      }
    } else {
      // Add new period to the term and save into database
      let {
        loading: loadAddTermPeriod,
        error: errorAddTermPeriod,
        data: dataAddTermPeriod,
      } = await termAddPeriod({
        variables: {
          termId: 4,
          name: name,
          noOfWeeks: noOfWeeks,
          inSprint: inSprint,
          startDate: startDate,
          endDate: endDate,
          desc: desc,
        },
      });
      if (
        !loadAddTermPeriod &&
        dataAddTermPeriod &&
        dataAddTermPeriod.addTermPeriod &&
        dataAddTermPeriod.addTermPeriod.termPeriod
      ) {
        // console.log(dataAddTermPeriod);
        setTermStartDate(endDate);
        setAlertMsg({
          title: "Success",
          msg: 'Period "' + name + '" is successfully saved.',
        });

        // Update periodDataList
        const newPeriod = {
          periodId: parseInt(dataAddTermPeriod.addTermPeriod.termPeriod.periodId),
          name,
          dateRange,
          startDate,
          endDate,
          desc,
          noOfWeeks,
          inSprint,
          sequence: dataAddTermPeriod.addTermPeriod.termPeriod.sequence,
          events: [],
        };
        updatedList = update(periodDataList, {
          $push: [newPeriod],
        });
      } else {
        console.log(errorAddTermPeriod);
        // alert(errorMutation);
      }
    }
    //console.log("updatedList_add__", updatedList);

    setPeriodDataList(updatedList);
    setLastDroppedComponent(null);
    setOpenEditPeriodDialog(false);
    setCurrentEditComponent(null);
  };
  const handleDoneAddEditEventObjectToPeriod = async (
    name,
    eventType,
    formatDate,
    scheduledDate,
    desc
  ) => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      periodId: addEditEventToPeridId,
    });
    if (!foundRow) {
      //Show alert msg of error from DB
      return;
    }
    //Currently the periodIndex and periodId are the same in static data.
    var periodIndex = periodDataList.findIndex(
      item => item.periodId === foundRow.periodId
    );

    // Getting eventTypeId by eventType name
    var foundEvent = termEvents.find(item => item.name === eventType);

    if (currentEditComponent) {
      var eventIndex = foundRow.events.findIndex(
        item => item.eventId === currentEditComponent.eventId
      );
      if (eventIndex !== -1 && foundEvent) {
        updatedList = update(periodDataList, {
          [periodIndex]: {
            events: {
              [eventIndex]: {
                name: { $set: name },
                eventType: { $set: eventType },
                formatDate: { $set: formatDate },
                scheduledDate: { $set: scheduledDate },
                desc: { $set: desc },
              },
            },
          },
        });

        // Edit event's data in DB
        const {
          loading: loadEditEvent,
          error: errorEditEvent,
          data: dataEditEvent,
        } = await editEvent({
          variables: {
            eventId: parseInt(currentEditComponent.eventId),
            eventTypeId: parseInt(foundEvent.eventTypeId),
            name: name,
            desc: desc,
            scheduledDate: scheduledDate,
            actualDate: scheduledDate,
          },
        });

        if (
          !loadEditEvent &&
          dataEditEvent &&
          dataEditEvent.editEvent &&
          dataEditEvent.editEvent.event
        ) {
          setAlertMsg({
            title: "Success",
            msg: 'Event "' + name + '" is successfully updated.',
          });
        } else if (errorEditEvent) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
      }
    } else {
      if (foundEvent) {
        let eventTypeId = parseInt(foundEvent.eventTypeId);
        if (foundRow.periodId && eventTypeId) {
          // Add new event to the period and save in DB
          const {
            loading: loadCreateEvent,
            error: errorCreateEvent,
            data: dataCreateEvent,
          } = await createEvent({
            variables: {
              periodId: foundRow.periodId,
              eventTypeId: eventTypeId,
              name: name,
              desc: desc,
              scheduledDate: scheduledDate,
              actualDate: scheduledDate, // Currently we set actualDate to scheduledDate
            },
          });
          if (errorCreateEvent) {
            setAlertMsg({
              title: "Error",
              msg: "Unfortunately an error occurred.",
            });
          } else if (dataCreateEvent && dataCreateEvent.createEvent) {
            setAlertMsg({
              title: "Success",
              msg: 'Event "' + name + '" is successfully saved.',
            });

            const newEvent = {
              eventId: dataCreateEvent.createEvent.event.eventId,
              name,
              eventType,
              formatDate,
              scheduledDate,
              desc,
              sequence: foundRow.events.length,
            };
            updatedList = update(periodDataList, {
              [periodIndex]: {
                events: {
                  $push: [newEvent],
                },
              },
            });
          }
        }
      }
    }
    //  console.log("updatedList_add_", updatedList);
    setPeriodDataList(updatedList);
    setLastDroppedComponent(null);
    setAddEditEventToPeridId(null);
    setOpenEditEventDialog(false);
    setCurrentEditComponent(null);
  };

  const handleDeletePeriod = async () => {
    if (
      !currentEditComponent ||
      (currentEditComponent && currentEditComponent.periodid !== undefined)
    )
      return;
    var periodIndex = periodDataList.findIndex(
      item => item.periodId === currentEditComponent.periodId
    );
    if (periodIndex === -1) return;

    // Delete Period from Database
    let {
      loading: loadDeleteTermPeriod,
      error: errorDeleteTermPeriod,
      data: dataDeleteTermPeriod,
    } = await termDeletePeriod({
      variables: {
        periodId: parseInt(currentEditComponent.periodId),
      },
    });
    if (errorDeleteTermPeriod) {
      setAlertMsg({
        title: "Error",
        msg: "Unfortunately an error occurred.",
      });
    } else if (!loadDeleteTermPeriod && dataDeleteTermPeriod) {
      setAlertMsg({
        title: "Success",
        msg: 'Period "' + currentEditComponent.name + '" is successfully removed.',
      });
    }
    // Update periodDataList
    const updatedList = update(periodDataList, {
      $splice: [[periodIndex, 1]],
    });
    setPeriodDataList(updatedList);
    setOpenEditPeriodDialog(false);
    setCurrentEditComponent(null);
  };
  const handleDeleteEvent = async () => {
    let updatedList = [];
    let foundRow = findAnd.returnFound(periodDataList, {
      periodId: addEditEventToPeridId,
    });
    if (!foundRow) {
      //Show alert msg of error from DB
      return;
    }
    var periodIndex = periodDataList.findIndex(
      item => item.periodId === foundRow.periodId
    );
    if (currentEditComponent) {
      var eventIndex = foundRow.events.findIndex(
        item => item.eventId === currentEditComponent.eventId
      );
      if (eventIndex !== -1) {
        updatedList = update(periodDataList, {
          [periodIndex]: {
            events: {
              $splice: [[eventIndex, 1]],
            },
          },
        });
      }
      // Delete event record from DB
      const {
        loading: loadingEventDelete,
        error: errorEventDelete,
        data: dataEventDelete,
      } = await deleteEvent({
        variables: {
          eventId: parseInt(currentEditComponent.eventId),
        },
      });

      if (errorEventDelete) {
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (dataEventDelete && dataEventDelete.deleteEvent) {
        setAlertMsg({
          title: "Success",
          msg: 'Event "' + currentEditComponent.name + '" is successfully removed.',
        });
      }
    }
    setPeriodDataList(updatedList);
    setAddEditEventToPeridId(null);
    setOpenEditEventDialog(false);
    setCurrentEditComponent(null);
  };

  if (loadContent)
    return (
      <div className={classes.cardContainer}>
        <Header breadcrumbs={[{ label: "Add Term", link: null }]} />
        <div className={classes.container}>
          <DndProvider backend={HTML5Backend}>
            <CustomGridContainer container spacing={1}>
              <Grid item style={{ width: 130 }}>
                <Card style={{ height: 450 }}>
                  <Box mb={1}>
                    <Box
                      mt={2}
                      mb={1}
                      ml={1}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <IconButton>
                        <img
                          src={backImg}
                          height={24}
                          onClick={() => navigate(`${project_url}/terms`)}
                        />
                      </IconButton>
                      <Typography
                        variant="h5"
                        className={classes.backStyle}
                        onClick={() => navigate(`${project_url}/terms`)}
                      >
                        Back
                      </Typography>
                    </Box>
                    <Divider />
                    <Typography variant="h2" style={{ paddingTop: 10 }}>
                      Period Objects
                    </Typography>
                    <Box pb={2}>
                      <Box className={classes.dragIconBoxStyle}>
                        <ComponentDragBox
                          component={PeriodComponents.PERIOD}
                          text="Period"
                          icon=""
                        />
                      </Box>
                    </Box>
                    <Divider />
                    <Typography variant="h2" style={{ paddingTop: 10 }}>
                      Event Objects
                    </Typography>
                    {termEvents.map(eventType => (
                      <Box className={classes.dragIconBoxStyle}>
                        <ComponentDragBox
                          component={eventType.name}
                          text={eventType.name}
                          icon=""
                        />
                      </Box>
                    ))}
                  </Box>
                </Card>
              </Grid>
              <Grid item style={{ width: 1270 }}>
                <Card
                  ref={cardRef}
                  style={{
                    minHeight: 430,
                    paddingBottom: 20,
                    maxWidth: 1270,
                    overflowX: "auto",
                  }}
                >
                  <Box
                    mb={1.5}
                    ml={3}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {!editingTermName ? (
                      <Box className={classes.termNameTextBoxStyle}>
                        <Typography
                          variant="h1"
                          className={classes.termNameTextStyle}
                          onClick={() => {
                            setEditingTermName(true);
                            setFocusTermName(true);
                          }}
                        >
                          {termName}
                        </Typography>
                        <IconButton>
                          <EditOutlinedIcon
                            onClick={() => {
                              setEditingTermName(true);
                              setFocusTermName(true);
                            }}
                          />
                        </IconButton>
                      </Box>
                    ) : (
                      <Box
                        style={{
                          paddingTop: 12,
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "start",
                          width: 400,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          id="outlined-multiline-static"
                          variant="outlined"
                          value={editedTermName}
                          inputRef={input => {
                            if (focusTermName && input != null) {
                              input.focus();
                            }
                          }}
                          className={classes.termNameFieldStyle}
                          onChange={e => {
                            setEditedTermName(e.target.value);
                          }}
                          onKeyDown={e => {
                            e.key === "Enter" && handleEditTermName();
                          }}
                        />

                        <Box className={classes.iconStyle} onClick={handleEditTermName}>
                          <CheckIcon sx={{ color: "gray", cursor: "pointer" }} />
                        </Box>

                        <Box
                          className={classes.iconStyle}
                          style={{ marginLeft: 7 }}
                          onClick={() => {
                            setEditingTermName(false);
                            setEditedTermName(termName);
                          }}
                        >
                          <CloseIcon sx={{ color: "gray", cursor: "pointer" }} />
                        </Box>
                      </Box>
                    )}
                    <Box
                      style={{
                        width: 200,
                        display: "flex",
                        paddingTop: 10,
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        size="small"
                        className={classes.buttonStyle}
                      >
                        Term Info
                      </Button>
                    </Box>
                  </Box>
                  <Divider ref={dividerRef} />
                  <Box mt={2} ml={2} mr={2}>
                    <Grid container>
                      {periodDataList.map(pd => (
                        <Grid
                          item
                          style={{
                            marginRight: 8,
                            width: 147,
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            style={{
                              border: "1px solid grey",
                              borderRadius: "8px",
                              height: "70px",
                              textAlign: "center",
                              backgroundColor: pd.inSprint ? "#E2F2FF" : "#FFFF80",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setCurrentEditComponent(pd);
                              setOpenEditPeriodDialog(true);
                            }}
                          >
                            <StyledTooltip title={pd.name}>
                              <Typography
                                variant="h6"
                                style={{
                                  fontWeight: 600,
                                  paddingLeft: 3,
                                  paddingRight: 5,
                                  paddingTop: 10,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "150px",
                                }}
                              >
                                {pd.name}
                              </Typography>
                            </StyledTooltip>
                            <Typography variant="h6" style={{ paddingTop: 8 }}>
                              {pd.dateRange}
                            </Typography>
                          </Box>
                          <Box pt={2}>
                            {pd.events.map(ev => (
                              <Grid
                                item
                                style={{
                                  width: 147,
                                  paddingTop: 7,
                                  marginRight: 8,
                                }}
                              >
                                <Box
                                  style={{
                                    border: "1px solid grey",
                                    borderRadius: "8px",
                                    height: "70px",
                                    textAlign: "center",
                                    backgroundColor: "#B7FFB7",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setCurrentEditComponent(ev);
                                    setAddEditEventToPeridId(pd.periodId);
                                    setOpenEditEventDialog(true);
                                  }}
                                >
                                  <StyledTooltip title={ev.name}>
                                    <Typography
                                      variant="h6"
                                      style={{
                                        fontWeight: 600,
                                        paddingLeft: 3,
                                        paddingRight: 5,
                                        paddingTop: 8,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "150px",
                                      }}
                                    >
                                      {ev.name}
                                    </Typography>
                                  </StyledTooltip>
                                  <Typography variant="h6" style={{ paddingTop: 4 }}>
                                    {ev.eventType}
                                  </Typography>
                                  <Typography variant="h6" style={{ paddingTop: 4 }}>
                                    {ev.formatDate}
                                  </Typography>
                                </Box>
                              </Grid>
                            ))}
                            <Grid
                              item
                              style={{
                                width: 147,
                                paddingTop: 7,
                                marginRight: 8,
                              }}
                            >
                              <EventDropBox
                                lastDroppedComponent={lastDroppedComponent}
                                onDrop={item => handleDropEvent(item, pd.periodId)}
                                passObjOptions={(
                                  name,
                                  eventType,
                                  formatDate,
                                  scheduledDate,
                                  desc
                                ) =>
                                  handleDoneAddEditEventObjectToPeriod(
                                    name,
                                    eventType,
                                    formatDate,
                                    scheduledDate,
                                    desc
                                  )
                                }
                                closeAddDialog={() => {
                                  setLastDroppedComponent(null);
                                  setAddEditEventToPeridId(null);
                                }}
                              />
                            </Grid>
                          </Box>
                        </Grid>
                      ))}
                      <Grid item style={{ width: 147 }}>
                        <PeriodDropBox
                          lastDroppedComponent={lastDroppedComponent}
                          termStartDate={termStartDate} //"2024-12-07" // we should set startDate from DB
                          onDrop={handleDropPeriod}
                          passObjOptions={(
                            name,
                            dateRange,
                            startDate,
                            endDate,
                            desc,
                            noOfWeeks,
                            inSprint
                          ) =>
                            handleDoneAddEditPeriodObjectToTerm(
                              name,
                              dateRange,
                              startDate,
                              endDate,
                              desc,
                              noOfWeeks,
                              inSprint
                            )
                          }
                          closeAddDialog={() => setLastDroppedComponent(null)}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>
              {openEditPeriodDialog && (
                <EditPeriodDialog
                  closeDialog={() => {
                    setOpenEditPeriodDialog(false);
                    setCurrentEditComponent(null);
                  }}
                  handleDeletePeriod={handleDeletePeriod}
                  handleDone={(
                    name,
                    dateRange,
                    startDate,
                    endDate,
                    desc,
                    noOfWeeks,
                    inSprint
                  ) =>
                    handleDoneAddEditPeriodObjectToTerm(
                      name,
                      dateRange,
                      startDate,
                      endDate,
                      desc,
                      noOfWeeks,
                      inSprint
                    )
                  }
                  periodName={currentEditComponent.name}
                  desc={currentEditComponent.desc}
                  startDate={currentEditComponent.startDate}
                  noOfWeeks={currentEditComponent.noOfWeeks}
                  inSprint={currentEditComponent.inSprint}
                />
              )}
              {openEditEventDialog && (
                <EditEventDialog
                  closeDialog={() => {
                    setOpenEditEventDialog(false);
                    setCurrentEditComponent(null);
                  }}
                  handleDeleteEvent={handleDeleteEvent}
                  termEvents={termEvents}
                  handleDone={(name, eventType, formatDate, scheduledDate, desc) =>
                    handleDoneAddEditEventObjectToPeriod(
                      name,
                      eventType,
                      formatDate,
                      scheduledDate,
                      desc
                    )
                  }
                  eventName={currentEditComponent.name}
                  scheduledDate={currentEditComponent.scheduledDate}
                  desc={currentEditComponent.desc}
                  eventType={currentEditComponent.eventType}
                />
              )}
            </CustomGridContainer>
          </DndProvider>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
            />
          )}
        </div>
      </div>
    );
  else return;
}

export default TermAdd;
